"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionBorderLine = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DashboardLayoutSectionBorderMarker_1 = require("./DashboardLayoutSectionBorderMarker");
exports.DashboardLayoutSectionBorderLine = function (props) {
    var position = props.position, status = props.status;
    return (react_1.default.createElement("div", { className: classnames_1.default("gd-fluidlayout-row-separator", "s-fluidlayout-row-separator", position, status) },
        react_1.default.createElement(DashboardLayoutSectionBorderMarker_1.DashboardLayoutSectionBorderMarker, { className: "gd-fluidlayout-row-separator-icon gd-fluidlayout-row-separator-icon-left", active: props.status === "active" }),
        react_1.default.createElement(DashboardLayoutSectionBorderMarker_1.DashboardLayoutSectionBorderMarker, { className: "gd-fluidlayout-row-separator-icon gd-fluidlayout-row-separator-icon-right", active: props.status === "active" })));
};
//# sourceMappingURL=DashboardLayoutSectionBorderLine.js.map